import { render, staticRenderFns } from "./HomeView.vue?vue&type=template&id=5de016a2&scoped=true&lang=pug"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de016a2",
  null
  
)

export default component.exports